var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgExclamationPoint = function SvgExclamationPoint(props) {
  var _id5 = useUniqueInlineId();
  var _id4 = useUniqueInlineId();
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    width: 23.2299,
    height: 28.5387,
    rx: 0.833854,
    transform: "matrix(0.965478 0.260483 -0.257164 0.966368 16.6929 1.75879)",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.00146484 1.60081C-0.00146484 0.755002 0.6842 0.0693359 1.53001 0.0693359H18.8099C19.2179 0.0693359 19.609 0.232136 19.8965 0.521623L28.4132 9.09704C28.6982 9.38394 28.8581 9.77188 28.8581 10.1762V34.1241C28.8581 34.9699 28.1724 35.6555 27.3266 35.6555H1.53001C0.6842 35.6555 -0.00146484 34.9699 -0.00146484 34.1241V1.60081Z",
    fill: "url(#".concat(_id2, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5771 13.2027C12.485 12.1779 13.2922 11.2949 14.3212 11.2949H14.4428C15.4717 11.2949 16.2789 12.1779 16.1868 13.2027L15.5016 20.831C15.4495 21.4105 14.9638 21.8546 14.382 21.8546C13.8001 21.8546 13.3144 21.4105 13.2624 20.831L12.5771 13.2027Z",
    fill: "url(#".concat(_id3, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5678 24.1629C15.5678 24.8223 15.0369 25.3568 14.382 25.3568C13.7272 25.3568 13.1963 24.8223 13.1963 24.1629C13.1963 23.5035 13.7272 22.969 14.382 22.969C15.0369 22.969 15.5678 23.5035 15.5678 24.1629Z",
    fill: "url(#".concat(_id4, ")")
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.4171 0.0693359L28.8278 9.54495H20.6805C19.9828 9.54495 19.4171 8.9793 19.4171 8.28154V0.0693359Z",
    fill: "url(#".concat(_id5, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: -3.23935,
    y1: 1.98982,
    x2: 1.60271,
    y2: 30.2539,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEAFF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDAFF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 26.0979,
    y1: 2.34298,
    x2: -6.82325,
    y2: 29.6369,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E2FF"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC1FF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 11.9996,
    y1: 25.0005,
    x2: 18.4752,
    y2: 11.9883,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F5FF"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F7FF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id4,
    x1: 11.9996,
    y1: 25.0005,
    x2: 18.4752,
    y2: 11.9883,
    gradientUnits: "userSpaceOnUse"
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F5FF"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F7FF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id5,
    x1: 17.9362,
    y1: 9.30485,
    x2: 19.3258,
    y2: -1.45549,
    gradientUnits: "userSpaceOnUse"
  }, _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F5FF"
  })), _stop0 || (_stop0 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F7FF"
  })))));
};
export default SvgExclamationPoint;